<template>
    <div>
        <div>
            <el-row>
                <h1 class="project_head_title">举报台账</h1>
                <el-divider class="divider" />
            </el-row>
            <el-form label-width="220px">
                <el-divider class="divider" />

                <el-row class="form-row">
                    <el-col :span="6">
                        <el-form-item label="被举报人姓名\工号" prop="labelValue">
                            <el-input v-model="queryForm.byComplaintPerson"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="被举报人事业部\二级单位" prop="labelValue">
                            <el-input v-model="queryForm.byComplaintDeptAll"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="举报人姓名\单位\手机\邮箱" prop="labelValue">
                            <el-input v-model="queryForm.person"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <el-button :disabled="loading" type="primary" icon="el-icon-search" @click="currentPage=1;getDataList()">搜索</el-button>
                            <!-- <el-button type="primary" icon="el-icon-download" @click="showDialog()">新增</el-button>
                            <el-button type="primary" @click="getDataList(true)">导出</el-button> -->
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div v-loading="loading">
                <el-table class="tb-mini" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border :data="datas" @selection-change="handleSelectionChange" align="center">
                    <el-table-column label="序号" type="index" width="70" align="center">
                        <template scope="scope">
                            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="byComplaintPersonName" label="被举报人姓名" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="byComplaintPersonId" label="被举报人工号" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="byComplaintDept" label="被举报人单位" show-overflow-tooltip min-width="150px"></el-table-column>
                    <!-- <el-table-column prop="byComplaintDept2" label="被举报人二级单位" show-overflow-tooltip min-width="150px"></el-table-column> -->
                    <el-table-column prop="complaintContent" label="举报内容" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="name" label="姓名" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="dept" label="单位" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="phone" label="手机" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="email" label="邮箱" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="createdStr" label="创建日期" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column  label="操作" width="250px" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" @click="toComplaint(scope.row.guid)" v-if="!scope.row.jobGuid">录入系统</el-button>
                            <!-- <el-button type="text" @click="showDialog(scope.row.guid)">修改</el-button> -->
                            <el-button type="text" @click="showDialog(scope.row.guid,true)">详情</el-button>
                            <!-- <el-button type="text" @click="deleteById(scope.row.guid)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[15, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    style="text-align:right"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" :title="detail?'详情':(dataForm.guid?'修改':'新增')" width="60%">
            <el-form label-width="150px" :rules="rules" ref="form" :model="dataForm" :disabled="detail" style="padding-right:100px;">
                <el-form-item label="被举报人姓名" prop="byComplaintPersonName">
                    <el-input v-model="dataForm.byComplaintPersonName" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="被举报人单位" prop="byComplaintDept">
                    <el-input v-model="dataForm.byComplaintDept" placeholder="" clearable/>
                </el-form-item>
                <!-- <el-form-item label="被举报人二级单位" prop="byComplaintDept2">
                    <el-input v-model="dataForm.byComplaintDept2" placeholder="" clearable/>
                </el-form-item> -->
                <el-form-item label="举报内容" prop="complaintContent">
                    <el-input v-model="dataForm.complaintContent" placeholder="" clearable type="textarea" maxlength="1000" show-word-limit :autosize="{minRows:3,maxRows:20}"/>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="dataForm.name" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="单位" prop="dept">
                    <el-input v-model="dataForm.dept" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="手机" prop="phone">
                    <el-input v-model="dataForm.phone" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="dataForm.email" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="文件" prop="" style="text-align: left;">
                    <Upload2 :disabled="detail" :fileIds="fileList" @getUploadFileIds="(val)=>{this.fileList=val;this.form.files = val.join(',')}"></Upload2>
                </el-form-item>
                <el-form-item label="图片" prop="" style="text-align: left;">
                    <Upload2 :disabled="detail" :fileIds="imgList" @getUploadFileIds="(val)=>{this.imgList=val;this.form.imgs = val.join(',')}"></Upload2>
                </el-form-item>
                <template v-if="detail">
                    <h1 class="project_head_title">进度</h1>
                    <el-form-item v-for="item in dataForm.items" :key="item.guid" :label="item.status">
                        <el-input disabled v-model="item.content" type="textarea" :autosize="{minROws:1,maxRows:8}"/>
                    </el-form-item>
                </template>
            </el-form>
            <span v-if="!detail" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
            <span v-else slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return {
            detail:false,
            queryForm:{
            },
            currentPage:1,
            pageSize:15,
            total: 0,
            datas: [],
            loading:false,
            dialogVisible:false,
            dataForm:{},
            imgList:[],
            fileList:[],
            rules:{
                labelValue:{required:true,message:'请填写数据',trigger:'blur'},
            },
            
            col:[['选项编号','label'],['选项名称','labelValue']]
        }
    },
		created(){

			document.title='举报台账'
		},
    mounted(){
        this.getDataList()
    },
    methods:{
        showDialog(id,detail = false){
            this.detail = detail
            this.dialogVisible = true
            this.dataForm = {}
            this.imgList = []
            this.fileList = []
            if(this.$refs['person']){
                this.$refs['person'].clearSelection()
            }
            if(this.$refs['form']){
                this.$refs['form'].resetFields()
            }
            
            if(id){
                this.$http.get('/api/ts/v0.1/complaint/'+id)
                .then(res=>{
                    this.dataForm = res.data
                    if(this.dataForm.imgs){
                        this.imgList = this.dataForm.imgs.split(',')
                    }
                    if(this.dataForm.files){
                        this.fileList = this.dataForm.files.split(',')
                    }
                    console.log(this.dataForm)
                })
            }
        },
        deleteById(id){
            this.$confirm('此操作将永久删除该数据，是否继续？','提示'
                ,{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(()=>{
                    this.$http.delete('/api/ts/v0.1/complaint/'+id).then(res=>{
                if (res.data >= 1) {
                    this.getDataList()
                    this.$message.success('操作成功')
                } else {
                    this.$message.error('操作失败')
                }
            }).catch((err)=>{
                this.$message.error('操作失败')
            })
                })
            
        },
        save(){
            console.log(this.dataForm,'1111111')
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    if(this.fileList && this.fileList.length>0){
                        this.dataForm.files = this.fileList.join(',')
                    }else{
                        this.dataForm.files = undefined
                    }
                    if(this.imgList && this.imgList.length>0){
                        this.dataForm.imgs = this.imgList.join(',')
                    }else{
                        this.dataForm.imgs = undefined
                    }
                    this.$http.post('/api/ts/v0.1/complaint/save',this.dataForm)
                    .then(res=>{
                        if (res.data >= 1) {
                            this.getDataList()
                            this.dialogVisible = false
                            this.$message.success('操作成功')
                        } else {
                            this.$message.error('操作失败')
                        }
                    })
                    .catch((err)=>{
                        this.$message.error('操作失败')
                    })
                }else{
                    this.$message.error('请填写数据')
                }
            })
            
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getDataList()
        },
        getDataList(isExport = false){
            if(isExport){
                this.queryForm.pageSize = 10000000
                this.queryForm.pageNum = 1
                this.exportDatas = []
            }else{
                this.queryForm.pageSize = this.pageSize
                this.queryForm.pageNum = this.currentPage
                this.datas = []
            }
            this.queryForm.spare = 'item'
            
            this.$http.get('/api/ts/v0.1/complaint/page',{params:{...this.queryForm}})
                .then(res=>{
                    if(res.status==200){
                        if(isExport){
                            this.$onExport(res.data.list,this.col,"举报台账")
                        }else{
                            this.datas = res.data.list
                            this.total = res.data.total
                        }
                    }else{
                        this.$message.error('查询失败！请联系管理员')
                    }
                    
                    this.loading=false;
                })
                .catch((err)=>{
                    this.loading=false;
                })
        },
        toComplaint(guid){
            window.open(this.Config.jobUrl+'/main/clue/editClueComplaint?mode=add&tsGuid='+guid,'_blank');
        }
    }
}
</script>

<style scoped>
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 100%;
    }
    .el-select{
        width:100%;
    }
    .el-input-number{
        width: 100%;
    }
</style>